import { Injectable } from '@angular/core';
import { RequestForLocationSearch } from "@afidium/ts-facade";
import { Yii } from "libraries/interfaces/Yii";

@Injectable()
export class DictionarySearchRequestService {

    public create(query: string): RequestForLocationSearch {
        return {
            query,
            languageCode: Yii?.translate?.config?.language || 'fr',
            recordset: {
                first: 0,
                nbrecord: 100,
            },
            locationTypeArray: ['airport'],
        };
    }

}
